import { ComplementaryConsolidation, complementaryConsolidationService } from '../api/complementaryConsolidation';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

/**
 * Initializes a service for patching consolidations complementary information
 *
 * @returns service function for patching
 */
const useComplementaryConsolidationService = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();

    return async (complementaryConsolidations: ComplementaryConsolidation[]) => {
        if (!authenticationData) {
            throw Error('Not authenticated');
        }

        return await complementaryConsolidationService(
            proxyBaseUrl,
            apiKey,
            applicationReferenceNumber,
            authenticationData,
            complementaryConsolidations,
        );
    };
};

export default useComplementaryConsolidationService;
